import { render, staticRenderFns } from "./joinEmploymentApproval.vue?vue&type=template&id=1d95ddc4"
import script from "./joinEmploymentApproval.vue?vue&type=script&lang=js"
export * from "./joinEmploymentApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports